import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetGRNV2 = createModule({
  base: 'GET_GRN_V2',
  apiDetails: SERVICE_ENDPOINT.GET_GRN,
  errors: { defaultError: false, customError: '' },
});

export { GetGRNV2 };
